 $('.scrollto').on('click', function (e) {
	e.preventDefault();

	let target = $(this).attr('href');
	if ($(target).length) {
		$('html, body').animate({
			scrollTop: $(target).offset().top - 120
		}, 600); // Adjust duration if needed
	}
});

if (window.location.hash && $(window.location.hash).length) {
	$('html, body').animate({
		scrollTop: $(window.location.hash).offset().top - 120
	}, 600);
}

$.validate({
	form : '.validate-form',
	modules : 'security',
	borderColorOnError: '',
});

$('.modal__theme--close').on('click', function() {
	$('.modal__theme').removeClass('open');
});



$('.modal__class-info--close').on('click', function() {

	var $target = $(this).attr('data-target');



	$($target).removeClass('open');
});

$('.toggle-info').on('click', function() {

	var $target = $(this).attr('data-target');



	$($target).addClass('open');
});


/*
	Toggle Menu
*/
$('.toggle__menu').on('click', function() {
	$('body').toggleClass('menu-open');
});


/*
	Alert
*/
function alertModal(title, message)
{
	$('#alert_title').text(title);
	$('#alert_message').text(message);
	$('.modal__alert').addClass('open');
}
$('#alert_hide').on('click', function() {
	$('.modal__alert').removeClass('open');
});


/*
	Selecy a bay
*/
$('.select__bay').on('click', function() {

	if ( !$(this).hasClass('disabled') )
	{
		$(this).addClass('selected');
		$('.select__bay').not(this).removeClass('selected');
		var $bay_id = $(this).attr('data-value');
		$('#bay_id').val($bay_id);
	}

});

$('#bay_id').on('change', function() {

	var $bay_id = $(this).val();

	if ( $bay_id == '' )
	{
		$('.select__bay').removeClass('selected');
	}
	else {
		var $target = '#bay_' + $bay_id;
		$($target).addClass('selected');
		$('.select__bay').not($target).removeClass('selected');
	}

});

/*
	Copy a code
*/
$(".copy_code").on('click', function() {
	var $btn = $(this);
	var textToCopy =  $(this).attr("data-code");

	// Create a temporary input element
	var $tempInput = $("<input>");
	$("body").append($tempInput);


	$tempInput.val(textToCopy).select();


	document.execCommand("copy");

	$btn.addClass("copied");

	setTimeout(function() {
		$btn.removeClass("copied");
	}, 3000);

	// Remove the temporary input element
	$tempInput.remove();
});




/*
	Toggle password visibility
*/
$('.toggle-password').on('click', function() {
	let input = $(this).siblings('input')[0];
	let $icon = $(this).find('.icon');

	if (input.type === 'password') {
		input.type = 'text';
		$icon.removeClass('icon--eye-slash').addClass('icon--eye');
	} else {
		input.type = 'password';
		$icon.removeClass('icon--eye').addClass('icon--eye-slash');
	}
});

